import ExportLeadComponent from "../components/smart/ExportLeadComponent";

function ExportLeadPage() {
    document.title = 'Export Leads';
    return (
        <>
            <h2> { `Export & Report Leads`} </h2>
            <ExportLeadComponent />
        </>
    );
}

export default ExportLeadPage;